<m-touch class="m-carousel" @tap="onTap" @click="onClick" @swipeleft="showNextItem" @swiperight="showPrevItem" :swipe-options="{direction: 'horizontal'}" tag="ul">
    <slot></slot>
</m-touch>
